/**
 * Prevents iOS Safari from treating a second tap as zoom or text-selection.
 * Intercepts the second tap of a double-tap and calls preventDefault().
 */

const DEFAULT_DOUBLE_TAP_MS = 500;

export function installPreventDoubleTap(
  target: EventTarget = document.body,
  doubleTapMs = DEFAULT_DOUBLE_TAP_MS,
): () => void {
  let timer = 0;
  let tapPending = false;

  const onTouchStart = (event: Event) => {
    clearTimeout(timer);
    if (tapPending) {
      event.preventDefault();
      tapPending = false;
    } else {
      tapPending = true;
      timer = window.setTimeout(() => {
        tapPending = false;
      }, doubleTapMs);
    }
  };

  target.addEventListener('touchstart', onTouchStart, { passive: false });

  return () => {
    target.removeEventListener('touchstart', onTouchStart);
    clearTimeout(timer);
  };
}
